<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/rewardPunish/list/${projectId}`">
      </f7-nav-left>
      <f7-nav-title>奖罚通知单</f7-nav-title>
      <f7-nav-right v-if="perms.rewardPunishAdd">
        <f7-link @click="editable = !editable" v-show="!editable">编辑</f7-link>
        <f7-link @click="add" v-show="editable">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <div class="base-info">
        <div class="base-row">
          <div class="base-label">奖罚单位：</div>
          <div class="base-text">
            {{ rewPunView.originDepartmentDesc }}
          </div>
        </div>
        <div class="base-row">
          <div class="base-label">项目名称：</div>
          <div class="base-text">
            {{ rewPunView.projectIdDesc }}
          </div>
        </div>
        <div class="base-row">
          <div class="base-label">奖罚签发人：</div>
          <div class="base-text">
            {{ rewPunView.issuanceIdDesc }}
          </div>
        </div>
        <div class="base-row">
          <div class="base-label">施工单位：</div>
          <div class="base-text">
            {{ rewPunView.targetDepartmentDesc }}
          </div>
        </div>
      </div>
      <div class="rewardPunish-type">
        <div class="rewardPunish-type-item" :key="item.code" v-for="item in typeList">
          <f7-radio
            color="orange"
            :name="item.name"
            :value="item.code"
            :checked="rewPun.type === item.code"
            @change="rewPun.type = $event.target.value"
            :disabled="!editable"
          ></f7-radio>
          &nbsp;
          <span>{{ item.name }}</span>
        </div>
      </div>
      <f7-list inline-labels id="rewPunForm">
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">奖罚日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-time"
            readonly
            required
            validate
            :disabled="!editable"/>
        </f7-list-input>
        <f7-list-input
          label="奖罚金额"
          type="number"
          :value="rewPun.amount"
          @input="rewPun.amount = $event.target.value"
          placeholder="请填写"
          required
          validate
          min=0
          max=10000000
          error-message='必须大于等于0，小于1000万'
          :disabled="!editable">
          <div slot="media" class="input-required">*</div>
          <div slot="inner-end">元</div>
        </f7-list-input>
        <f7-list-input
          label="奖罚事由"
          type="textarea"
          :value="rewPun.remark"
          @input="rewPun.remark = $event.target.value"
          placeholder="请填写"
          required
          validate
          error-message='必填项，长度2-500字符'
          minlength=2
          maxlength=500
          resizable
          :disabled="!editable">
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
      </f7-list>
      <div class="img-show-area">
        <div class="img-show" v-for="item in rewPun.attachmentList" :key="item">
          <img
            :src="`${imageUrl}?attachmentId=${item}`"
            width="100%"
            height="100%"
            v-if="editable" />
          <img
            :src="`${imageUrl}?attachmentId=${item}`"
            width="100%"
            height="100%"
            @click="browserPhoto(rewPun.attachmentList)" v-if="!editable" />
          <div class="img-show-close" @click="removeOldFile(item)" v-if="editable">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show" v-for="file in files" :key="file.id">
          <img v-if="file.thumb" :src="file.thumb" width="100%" height="100%" />
          <span v-else>无图片</span>
          <div class="img-show-close" @click="removeFile(file)">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show" v-if="editable">
          <file-upload
            class="file-upload"
            input-id="rewPunFile"
            :post-action="uploadURL"
            :extensions="extensions"
            :accept="accept"
            :multiple="multiple"
            :size="size || 0"
            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
            :add-index="addIndex"
            v-model="files"
            @input-filter="inputFilter"
            ref="rewPunUpload">
            <f7-icon fa="plus" size="1rem"></f7-icon>
          </file-upload>
        </div>
        <div class="img-show" v-else></div>
        <div
          class="img-show"
          v-if="(rewPun.attachmentList.length + files.length + 1) % 3 > 0
            && (rewPun.attachmentList.length + files.length + 1) % 3 <= 1">
        </div>
        <div
          class="img-show"
          v-if="(rewPun.attachmentList.length + files.length + 1) % 3 > 0
            && (rewPun.attachmentList.length + files.length + 1) % 3 <= 2">
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { getDict, imageView, uploadFileUrl } from '@/api/common';
import { createCalendar, createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getRewardPunishBase, getRewardPunish, addRewardPunish } from '@/api/rewardPunish';
import { RewPun } from '@/model/reqObject';
import FileUpload from 'vue-upload-component';

export default {
  props: ['projectId'],
  components: {
    FileUpload,
  },
  data() {
    return {
      editable: lodash.isEmpty(this.$f7route.query.id),
      imageUrl: imageView,
      rewPunView: {},
      rewPun: new RewPun({ projectId: this.projectId }),
      typeList: [],
      files: [],
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadURL: uploadFileUrl,
      flag: true,
      perms: { rewardPunishAdd: !lodash.isEmpty(this.$f7route.query.flag) },
    };
  },
  mounted() {
    this.init();

    this.$watch(
      () => this.flag && this.files.length !== 0
        && this.$refs.rewPunUpload && this.$refs.rewPunUpload.uploaded,
      (newVal) => {
        if (newVal) {
          this.addObj();
        }
      },
    );
  },
  methods: {
    browserPhoto(itemArr) {
      this.$f7.photoBrowser.create({
        photos: (itemArr || []).map(item => `${this.imageUrl}?attachmentId=${item}`),
        backLinkText: '返回',
        navbarOfText: '/',
        iconsColor: 'white',
        routableModals: false,
      }).open();
    },
    setErrorMsg(elem) {
      elem.addClass('input-invalid');
      let tmpNode = elem;
      while (this.$$(tmpNode).parent() && this.$$(tmpNode).parent().length !== 0) {
        if (tmpNode.hasClass('item-content')) {
          tmpNode.addClass('item-input-with-error-message');
          tmpNode.addClass('item-input-invalid');
          break;
        } else {
          tmpNode = this.$$(tmpNode).parent();
        }
      }
    },
    add() {
      this.flag = false;
      // this.$f7.input.validateInputs('#rewPunForm');
      if (lodash.isEmpty(this.rewPun.issuanceTime)) {
        this.setErrorMsg(this.$$('#calendar-time'));
      }
      if (lodash.isEmpty(this.rewPun.type)) {
        createToast(this, '请选择奖励或者惩罚');
        return;
      }
      let valided = true;
      this.$$('#rewPunForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (valided &&
        (this.files.length === 0
          || (this.$refs.rewPunUpload && this.$refs.rewPunUpload.uploaded))) {
        this.addObj();
      } else if (valided && this.files.length > 0) {
        this.$f7.dialog.preloader('正在上传数据');
        this.$refs.rewPunUpload.active = true;
        this.flag = true;
      }
    },
    addObj() {
      let uploadValid = true;
      const fileIdList = this.rewPun.attachmentList || [];
      this.files.forEach((file) => {
        uploadValid = uploadValid && (file.response.code === 0);
        if (file.response.code === 0) {
          fileIdList.push(file.response.data.id);
        }
      });
      if (uploadValid) {
        this.files = [];
        this.$set(this.rewPun, 'attachmentList', lodash.uniq(fileIdList));
        this.$set(this.rewPun, 'projectId', this.projectId);
        addRewardPunish(this.rewPun).then((result) => {
          this.$f7.dialog.close();
          if (result.code === 0) {
            this.editable = false;
            createToast(this, '添加成功');
            this.$f7router.back(`/rewardPunish/list/${this.projectId}`);
          }
        });
      }
    },
    init() {
      const dictKeys = ['rewardPunishType'];
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.typeList = result.data.rewardPunishType.codeVoList || [];
      });
      const id = this.$f7route.query.id;
      if (lodash.isEmpty(id)) {
        getRewardPunishBase({ projectId: this.projectId }).then((result) => {
          if (result.code === 0) {
            this.rewPunView = result.data || {};
            this.rewPun = new RewPun({ issuanceTime: dateFormat(new Date()) });
          }
          createCalendar(this, '#calendar-time', 'rewPun', 'issuanceTime');
        });
      } else {
        getRewardPunish({ projectId: this.projectId, id }).then((result) => {
          if (result.code === 0) {
            this.rewPunView = result.data || {};
            this.rewPun = new RewPun(result.data);
            this.perms = result.perms || {};
          }
          createCalendar(this, '#calendar-time', 'rewPun', 'issuanceTime');
        });
      }
    },
    toggleFinished(e) {
      this.$set(this.rewPun, 'finished', e ? '1' : '0');
    },
    removeFile(oldFile) {
      if (this.files.includes(oldFile)) {
        this.files.splice(this.files.findIndex(item => item.id === oldFile.id), 1);
      }
    },
    removeOldFile(id) {
      if (this.rewPun.attachmentList.includes(id)) {
        this.rewPun.attachmentList.splice(
          this.rewPun.attachmentList.findIndex(item => item === id), 1);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        Object.assign(newFile, { blob: '' });
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          Object.assign(newFile, { blob: URL.createObjectURL(newFile.file) });
        }
        Object.assign(newFile, { thumb: '' });
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          Object.assign(newFile, { thumb: newFile.blob });
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .base-info {
    padding: 0.5rem 0.5rem;
    border-radius: 0.3rem;
    background-color: #FFF8ED;
  }

  .base-row {
    padding: 0.5rem 0rem;
    display: flex;
    align-items: center;
  }

  .base-label {
    font-size: 0.9rem;
    color: $second-font-color;
  }

  .base-text {
    flex: auto;
    font-size: 0.9rem;
    color: $font-color;
  }

  .rewardPunish-type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 5rem;
    margin-top: 0.5rem;
    margin-bottom: -0.5rem;
    border-bottom: 0.05rem solid $border-color;
    background-color: $bg-color;
    border-radius: 0.3rem;
  }

  .rewardPunish-type-item {
    display: flex;
    align-items: center;
  }

  .img-show-area {
    border-top: 0.05rem solid $border-color;
    text-align: center;
    padding: 1rem 0rem;
    display: flex;
    flex-flow:row wrap;
    align-items: flex-start;
    justify-content: space-around;
  }

  .img-show {
    width: 30%;
    height: 6rem;
    padding: 0.5rem 0rem;
    position: relative;
  }

  .img-show-close {
    color: $white-color;
    height: 1rem;
    width: 1rem;
    line-height: 1rem;
    position: absolute;
    right: 0rem;
    top: 0.5rem;
    text-align: center;
    background-color: $theme-color;
    cursor: pointer;
  }

  .file-upload {
    background-color: $panel-bg-color;
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/rewardPunish/add.vue